import React, {useEffect, useState} from 'react';
import {Button, SvgIcon, Tab, Tabs} from "@mui/material";
import localStrings from "../../../localStrings";
import {getUriSetting, saveUriSetting, SELECTED_TAB} from "../../../utils/optionsUriLocalStorage";
import useAuth from "../../../hooks/useAuth";
import PageWithTitle from "../../../components/pages/pageWithTitle";
import {Link as RouterLink, useParams} from "react-router-dom";
import {
    chartImplementationListRoute,
    dashboardBaseRoute, dataGridImplementationListRoute,
    establishmentListRoute,
} from "../../../routes/dashboard";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {MODE_EDIT} from "../../../components/CrudFrom/GeneralEditor";
import EstablishmentCreateUpdateForm from "../../Establishments/EstablishmentAddView/EstablishmentCreateUpdateForm";
import ChartImplementationCreateUpdateForm from "../DataGridImplementationAddView/DataGridImplementationCreateUpdateForm";
import Integration from "../../Establishments/EstablishmentDetailsView/Integration";
import RhMapping from "../../Establishments/EstablishmentDetailsView/rhMapping";
import ViewChartImplementation from "./ViewChartImplementation";
import MDDescription from "./MDDescription";
import DataGridImplementationCreateUpdateForm
    from "../DataGridImplementationAddView/DataGridImplementationCreateUpdateForm";
import GridEdit from "./GridEdit";
import {executeQueryUtil} from "../../../utils/gqlUtil";
import {getDataGridImplementationQuery} from "../../../gql/dataGridImplementationGql";

const ChartImplementationDetailsView = () => {
    const {currentBrand} = useAuth()
    const [currentTab, setCurrentTab] = useState(getUriSetting(SELECTED_TAB) || 'general');
    let {dataGridImplementationId} = useParams();


    const [dataGridImplementation, setDataGridImplementation] = useState(null);
    const [reload, setReload] = useState(false);

    useEffect(() => {
        const loaData = async () => {
            let res =
                await executeQueryUtil(getDataGridImplementationQuery(dataGridImplementationId))
            setDataGridImplementation(res?.data?.getDataGridImplementation);
        }
        loaData()
    }, [dataGridImplementationId, reload]);

    const searchParams = new URLSearchParams(window.location.search);
    const urlBack = searchParams.get('urlBack');
    const urlBackTitle = searchParams.get('urlBackTitle');

    const handleTabsChange = (event, value) => {
        saveUriSetting(SELECTED_TAB, value)
        setCurrentTab(value);
    };

    function getMainButtons() {
        return (
            <>
                {urlBack && urlBackTitle &&
                    <RouterLink to={decodeURI(urlBack)}
                                style={{ textDecoration: 'none' }}
                    >
                        <Button
                            color="primary"
                            variant="contained"
                            startIcon={(
                                <SvgIcon>
                                    <ArrowBackIcon />
                                </SvgIcon>
                            )}
                        >
                            {urlBackTitle}
                        </Button>
                    </RouterLink>
                }
                <RouterLink to={'/' + dashboardBaseRoute + '/' + dataGridImplementationListRoute}
                            style={{ textDecoration: 'none' }}
                >
                    <Button
                        color="primary"
                        variant="contained"
                        startIcon={(
                            <SvgIcon>
                                <ArrowBackIcon />
                            </SvgIcon>
                        )}
                    >
                        {localStrings.backToList}
                    </Button>
                </RouterLink>
            </>
        )
    }

    return (
        <PageWithTitle title={localStrings.chartImplementation} mainButtons={getMainButtons()}>


            <Tabs
                onChange={handleTabsChange}
                scrollButtons="auto"
                value={currentTab}
                textColor="secondary"
                variant="scrollable"
            >
                <Tab label={localStrings.general} value="general"/>
                <Tab label={localStrings.gridEdit} value="gridEdit"/>
                <Tab label={localStrings.description} value="description"/>

            </Tabs>
            {currentTab === 'general' && <DataGridImplementationCreateUpdateForm modeEdit={MODE_EDIT}/>}
            {currentTab === 'gridEdit' && <GridEdit
                reloadTrigger={() => setReload(!reload)}
                dataGridImplementation={dataGridImplementation}/>
            }
            {currentTab === 'description' && <MDDescription
                reloadTrigger={() => setReload(!reload)}
                dataGridImplementationId={dataGridImplementationId}/>
            }
        </PageWithTitle>
    );
};

export default ChartImplementationDetailsView;
